import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "./common/Card";
import Grid from "@material-ui/core/Grid";
import Typography from "./common/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import crioLogo from "../../src/assets/crio-logo-white.svg";
import axios from "axios";
import Loader from "./common/Loader/Loader";

import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import myJson from "../data/data.json";

const styles = (theme) => ({
  top: {
    borderBottom: "1px solid" + theme.palette.primary.primaryBorder,
    padding: "0px 55px 60px 55px",
  },
  middle: {
    margin: "45px 55px",
  },
  subtitle: {
    display: "flex",
    alignItems: "center",
  },
  socialIcon: {
    color: theme.palette.primary.primary,
    fontSize: "32px",
    marginLeft: "20px",
  },
  arrowIcon: {
    color: theme.palette.primary.primary,
    marginLeft: "5px",
    cursor: "pointer",
  },
  programs: {
    margin: "45px 0px",
    color: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    alignItems: "center",
  },

  programRow: { padding: "60px 0px 0px 0px" },
  MERow: {
    margin: "55px 0px 0px 0px",
  },
  programPill: {
    display: "inline-flex",
    alignItems: "center",
    background: "#3f3f3f",
    width: "fit-content",
    padding: "16px",
    borderRadius: "8px",
    margin: "10px 0px",
  },
});
class MEDetail extends Component {
  constructor(props) {
    super(props);
    this.state = { meDetail: {}, data: "", me: "", isLoading: true };
  }
  componentDidMount() {
    let currentME = this.props.match.params.meid;
    this.setState({ me: currentME }, () => {});
    this.container.scrollTop = 0;
  }

  render() {
    if (!this.props.location.data) {
      window.location = "/";
    }
    const { classes } = this.props;
    return (
      <Grid container ref={(el) => (this.container = el)}>
        <Grid row lg={2} md={1} xs={1}></Grid>
        <Grid row lg={7} md={10} xs={10}>
          <Card>
            <>
              <Link
                to={{
                  pathname: "/",
                }}
              >
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <FontAwesomeIcon
                    icon={["fas", "arrow-left"]}
                    style={{
                      fontSize: "1.5em",
                      margin: "0px 10px 0px 55px",
                      cursor: "pointer",
                      color: "#999",
                    }}
                  ></FontAwesomeIcon>
                  <Typography cursor="pointer" color="#999">
                    Back
                  </Typography>
                </div>
              </Link>
              <div className={classes.top}>
                <Grid container>
                  <Grid item xs={12}>
                    <div style={{ margin: "0px 0px 10px 0px" }}>
                      <Typography fontSize="46px">
                        {this.props.location.data.meName}
                      </Typography>
                    </div>
                    <Typography fontSize="30px" color="rgba(0,0,0,0.6)">
                      {ReactHtmlParser(this.props.location.data.title)}{" "}
                    </Typography>
                    <Typography fontSize="14px">
                      {ReactHtmlParser(this.props.location.data.description)}{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={5} style={{ textAlign: "right" }}></Grid>
                  <Grid item xs={12}>
                    <div style={{ textAlign: "center" }}>
                      {ReactHtmlParser(this.props.location.data.image)}{" "}
                    </div>
                  </Grid>
                </Grid>
              </div>
              <div className={classes.middle}>
                <Typography color="rgba(0,0,0,1)" fontSize="20px">
                  {this.props.location.data.meName} Modules
                </Typography>
                <ul className="timeline">
                  {this.props.location.data.milestones.map((ele, idx) => (
                    <>
                      <li>
                        <div className={classes.MERow} class="meRow">
                          <Grid container>
                            <Grid item xs={12}>
                              <Typography type="heading3" color="rgba(0,0,0,1)">
                                {ReactHtmlParser(ele.title)}
                              </Typography>
                              <div style={{ marginTop: "16px" }}>
                                <Grid container>
                                  <Grid item xs={12} md={12} lg={12}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,0.6)"
                                    >
                                      Scope of work:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} md={12} lg={12}>
                                    <br></br>
                                    <Typography type="body5" color="#000">
                                      {ReactHtmlParser(ele.data)}
                                    </Typography>
                                  </Grid>
                                </Grid>

                                <div style={{ marginTop: "25px" }}>
                                  <Grid item xs={12} md={2}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,0.6)"
                                    >
                                      Skills Learned:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} md={10}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,1)"
                                    >
                                      {ReactHtmlParser(ele.skills)}
                                    </Typography>
                                  </Grid>
                                </div>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </li>
                      {idx !==
                      this.props.location.data.milestones.length - 1 ? (
                        <div
                          style={{
                            borderBottom: "1px solid #d8d8d8",
                            margin: "30px 0px 30px 80px",
                          }}
                        ></div>
                      ) : (
                        ""
                      )}
                    </>
                  ))}
                </ul>
              </div>
            </>
          </Card>
        </Grid>
        <Grid row lg={2} md={1} xs={1}></Grid>
      </Grid>
    );
  }
}
export default withStyles(styles)(MEDetail);
